import { Box, styled } from '@mui/material';
import { RGBColor } from 'react-color';

export const StyledHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledSliderWrapper = styled(Box)(({ theme }) => ({
  height: 16,
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
}));

export const StyledFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledInputsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const StyledPreviewColorComponent = styled(Box)<{ rgb: RGBColor; alpha: number }>(({ theme, rgb, alpha }) => ({
  width: 32,
  height: 32,
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider}`,
  flexShrink: 0,
  backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`,
}));

export const StyledSaturationWrapper = styled(Box)(({ theme }) => ({
  width: 224,
  height: 224,
  position: 'relative',
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
}));

export const StyledPickerContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));
